export const RECAPTCHA_HEADERS = {
    TOKEN: "recaptcha-token",
    MISSING_SCRIPT: "recaptcha-missing-script",
    SCRIPT_START_TIME: "recaptcha-script-start-time",
    SCRIPT_END_TIME: "recaptcha-script-end-time",
    RETRY_COUNT: "recaptcha-retry-count",
    BROWSER_ERROR_EMAIL: "browser-error-email",
};
